/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocument } from './InboundDocument';
import {
    InboundDocumentFromJSON,
    InboundDocumentFromJSONTyped,
    InboundDocumentToJSON,
    InboundDocumentToJSONTyped,
} from './InboundDocument';

/**
 * 
 * @export
 * @interface InboundDocumentsFindAllResponse
 */
export interface InboundDocumentsFindAllResponse {
    /**
     * 
     */
    data: Array<InboundDocument>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the InboundDocumentsFindAllResponse interface.
 */
export function instanceOfInboundDocumentsFindAllResponse(value: object): value is InboundDocumentsFindAllResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function InboundDocumentsFindAllResponseFromJSON(json: any): InboundDocumentsFindAllResponse {
    return InboundDocumentsFindAllResponseFromJSONTyped(json, false);
}

export function InboundDocumentsFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentsFindAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(InboundDocumentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function InboundDocumentsFindAllResponseToJSON(json: any): InboundDocumentsFindAllResponse {
    return InboundDocumentsFindAllResponseToJSONTyped(json, false);
}

export function InboundDocumentsFindAllResponseToJSONTyped(value?: InboundDocumentsFindAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(InboundDocumentToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

